// @flow
import React from 'react';

import { SeeMore } from 'Components/frameworks/see-more/SeeMore.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

export type TextSeeMoreProps = {
  className?: string,
  hasNoScrollOnCollapse?: boolean,
  isCollapseEnabled?: boolean,
  offsetScrollSelector?: string,
  onClick?: (SyntheticEvent<>) => void,
  seeLessLabel?: string,
  seeMoreLabel?: string,
  seeMoreSize?: number,
  seeMoreTheme?: string,
};

export function TextSeeMore(props: TextSeeMoreProps) {
  const {
    className,
    hasNoScrollOnCollapse,
    isCollapseEnabled,
    offsetScrollSelector,
    onClick,
    seeLessLabel,
    seeMoreLabel,
    seeMoreSize,
    seeMoreTheme,
    ...textProps
  } = props;

  return (
    <SeeMore
      className={className}
      hasNoScrollOnCollapse={hasNoScrollOnCollapse}
      isCollapseEnabled={isCollapseEnabled}
      offsetScrollSelector={offsetScrollSelector}
      onClick={onClick}
      seeLessLabel={seeLessLabel}
      seeMoreLabel={seeMoreLabel}
      seeMoreSize={seeMoreSize}
      theme={seeMoreTheme}
    >
      <Text {...textProps} />
    </SeeMore>
  );
}
